export enum UserRoles {
  MANAGER = 'manager',
  WAITER = 'waiter',
  OWNER = 'owner',
  ADMIN = 'admin',
}

export type UserRole = UserRoles.OWNER | UserRoles.ADMIN | UserRoles.MANAGER | UserRoles.WAITER
